/**
 * @file help.module.ts
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { PipesModule } from '@shared/pipes';
import { MaterialModule } from '@core/modules';
import { HelpRoutingModule } from './help-routing.module';
import { HelpComponent } from './help.component';
import { TpaFAQComponent } from './tpa-faq/tpa-faq.component';
import { CustomerSupportComponent } from './customer-support/customer-support.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { SetImagePathDirective } from '@shared/directives';


@NgModule({
  declarations: [HelpComponent, TpaFAQComponent, CustomerSupportComponent, PrivacyPolicyComponent, TermsOfUseComponent],
  imports: [
    CommonModule,
    HelpRoutingModule,
    FormsModule,
    MaterialModule,
    PipesModule,
    SetImagePathDirective
  ], exports: [
    PrivacyPolicyComponent,
    TermsOfUseComponent,
    TpaFAQComponent
  ]
})
export class HelpModule { }
